var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('i',{staticClass:"far fa-map-marker-alt fa-fw"}),_vm._v(" "+_vm._s(_vm.$t('EVENTS.LABEL.EVENT_LOCATION'))+": "+_vm._s(_vm.locationAddress)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }